import { useLayoutEffect, useState } from 'react';

export type WindowOrientation = 'landscape' | 'portrait';

export type WindowDimension = {
    width: number;
    height: number;
    orientation: WindowOrientation;
};

const useWindowDimension = () => {
    const [size, setSize] = useState<WindowDimension>({ width: 0, height: 0, orientation: 'landscape' });

    useLayoutEffect(() => {
        const updateSize = () => {
            setSize({
                width: window.innerWidth,
                height: window.innerHeight,
                orientation: window.innerWidth > window.innerHeight ? 'landscape' : 'portrait',
            });
        };

        window.addEventListener('resize', updateSize);

        updateSize();

        return () => window.removeEventListener('resize', updateSize);
    }, []);

    return size;
};

export default useWindowDimension;
